// columnInfo  - metadata related to the column
// editConfig  - if header is editable, this will contain all the handlers, icons, etc
// total       - if any totals are needed to be displatyed, such as profit total inside the header, the functionality is handled by this object

import { formatValue } from "../../../utils/utils";

// formatValue - helper function to format currency values, can extended to handle other cases actuall
const Header = ({ columnInfo, totals = {} }) => {
  return (
    <div className="flex flex-col gap-1 justify-center w-full">
      <span className="w-full truncate">{columnInfo.display}</span>
      {totals[columnInfo.key] !== undefined && (
        <p className="text-blue-500">
          {formatValue(totals[columnInfo.key], columnInfo.type, columnInfo)}
        </p>
      )}
    </div>
  );
};

export default Header;
